<div class="settings-page">
    <div class="content-box">

        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>Registru</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Registru</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('indoc-module.registre-documente.download')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="download()">
                                <i class="fa-solid fa-download"></i>
                                Descarcă PDF
                            </button>
                        </div>
                    </div>

                    <div class="card-container p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Număr document</mat-label>
                                        <input matInput type="number" formControlName="numar_registru" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Categorii document</mat-label>
                                        <mat-select formControlName="id_categorii" multiple>
                                            <mat-option *ngFor="let categorie of categorii" [value]="categorie.id">
                                                {{ categorie.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint>Gol = toate tipurile.</mat-hint>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Stadiu activitate</mat-label>
                                        <mat-select formControlName="activity_status" multiple>
                                            <mat-option *ngFor="let status of activityStatusOptions"
                                                [value]="status.id">
                                                {{ status.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint>Gol = toate stadiile.</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>

                        <div class="row" *ngIf="hasSelectedFilters">
                            <div class="col-12">
                                <div class="selected-filters">
                                    <div class="selected-filters__head">
                                        <span class="selected-filters__title">Filtre selectate</span>
                                        <button type="button" class="selected-filters__clear"
                                            (click)="clearSelectedFilters()">
                                            Șterge tot
                                        </button>
                                    </div>

                                    <div class="selected-filters__group" *ngIf="selectedCategorii.length">
                                        <span class="selected-filters__label">Categorii document:</span>
                                        <span class="filter-chip" *ngFor="let categorie of selectedCategorii">
                                            <span class="filter-chip__text">{{ categorie.name }}</span>
                                            <mat-icon class="filter-chip__remove"
                                                (click)="removeCategorie(categorie.id)">cancel</mat-icon>
                                        </span>
                                    </div>

                                    <div class="selected-filters__group" *ngIf="selectedActivityStatus.length">
                                        <span class="selected-filters__label">Stadiu activitate:</span>
                                        <span class="filter-chip" *ngFor="let status of selectedActivityStatus">
                                            <span class="filter-chip__text">{{ status.name }}</span>
                                            <mat-icon class="filter-chip__remove"
                                                (click)="removeActivityStatus(status.id)">cancel</mat-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row w-100">
                            <div class="col d-flex justify-content-start">
                                <button (click)="toggleCard()" type="button"
                                    class="btn btn-sm btn-warning closeBtn">Închide</button>
                            </div>
                            <div class="col buttons-submit">
                                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                    Resetează
                                </button>
                                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                                    Aplică
                                </button>
                            </div>
                        </div>

                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_0_days'
                                                " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PÂNĂ LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="row g-2 px-2 pb-2">
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <mat-form-field class="w-100 serie-filter">
                                <mat-label>Serie</mat-label>
                                <mat-select [formControl]="serieControl" (openedChange)="onSerieSelectClosed()"
                                    (selectionChange)="rerenderDT(true)">
                                    <mat-form-field class="px-2 w-100 sticky-input">
                                        <input matInput [formControl]="seriiControl"
                                            (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                    </mat-form-field>

                                    <mat-option *ngIf="filteredSerii.length === 0" disabled>
                                        <span>No results found</span>
                                    </mat-option>

                                    <mat-option [value]="-1">-- Alegeți --</mat-option>

                                    <mat-option *ngFor="let serie of filteredSerii" [value]="serie.id">
                                        {{ serie.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="px-2 pb-2" *ngIf="categoryCounts.length">
                        <div class="kpi-group-title">Categorii document</div>
                        <div class="row g-2 kpi-grid">
                            <div class="col-md col-sm-6">
                                <div class="kpi-card kpi-total">
                                    <div class="kpi-icon-wrap">
                                        <mat-icon>description</mat-icon>
                                    </div>
                                    <div class="kpi-text">
                                        <div class="kpi-value">{{ totalDocuments }}</div>
                                        <div class="kpi-label">Total documente</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md col-sm-6" *ngFor="let category of categoryCounts">
                                <div class="kpi-card" [ngClass]="categoryClass(category.id_categorie)">
                                    <div class="kpi-icon-wrap">
                                        <mat-icon>{{ categoryIcon(category.id_categorie) }}</mat-icon>
                                    </div>
                                    <div class="kpi-text">
                                        <div class="kpi-value">{{ category.total }}</div>
                                        <div class="kpi-label" [title]="category.categorie">{{ category.categorie }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="px-2 pb-2" *ngIf="statusCards.length">
                        <div class="kpi-group-title">Stadiu activitate</div>
                        <div class="row g-2 kpi-grid">
                            <div class="col-md col-sm-6" *ngFor="let card of statusCards">
                                <div class="kpi-card" [ngClass]="card.cssClass">
                                    <div class="kpi-icon-wrap">
                                        <mat-icon>{{ card.icon }}</mat-icon>
                                    </div>
                                    <div class="kpi-text">
                                        <div class="kpi-value">{{ card.value }}</div>
                                        <div class="kpi-label">{{ card.label }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>